import { SxProps } from '@mui/material'
import { theme } from '@dtx-company/shared-components/src'

// 68 is the default list item height
const LIST_ITEM_HEIGHT = 68
const VISIBLE_LIST_ITEM_MAX_COUNT = 3
export const AUTOCOMPLETE_LISTBOX_HEIGHT = `${LIST_ITEM_HEIGHT * VISIBLE_LIST_ITEM_MAX_COUNT}px`

export const AUTOCOMPLETE_STYLES: SxProps = {
  width: '100%',
  '& label': {
    color: theme.colors.primary.grey,
    fontSize: '12px'
  },
  '& input': {
    mt: '8px',
    padding: '12px',
    paddingLeft: '44px',
    borderRadius: '4px',
    width: '100%',
    boxSizing: 'border-box',
    border: `1px solid ${theme.colors.secondary.border}`,
    '&:focus': {
      border: '1px solid black',
      outline: 0
    }
  }
}

export const ICON_STYLES: SxProps = {
  display: 'flex',
  position: 'absolute',
  top: '8px',
  height: '44px',
  width: '44px',
  alignItems: 'center',
  justifyContent: 'center'
}
